import useMixpanelEventTracking from './useMixpanelEventTracking';

export default useMixpanelEventTracking;
